import styled from 'styled-components';
import { StyledPaperContainer } from '../../../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';

const ClickablePaper = styled(StyledPaperContainer)<{
  $showRedBorder?: boolean;
}>(props => ({
  cursor: 'pointer',
  border: '1px solid #E0E0E0',
  transition: '0.2s',
  borderColor: props.$showRedBorder ? '#FF0000' : '#E0E0E0',
  '&:hover': {
    transition: '0.1s',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  '&&': {
    borderRadius: '4px'
  }
}));

export default ClickablePaper;
